<script setup lang="ts"></script>

<template>
  <NovaLayoutWrapper>
    <NovaLayoutDefault>
      <template #center>
        <slot />
      </template>
    </NovaLayoutDefault>
  </NovaLayoutWrapper>
</template>
